import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BsShieldLock } from 'react-icons/bs';

export default function NoAccess() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex items-center justify-center p-10">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <div className="w-12 h-12 mx-auto rounded-xl bg-slate-100 text-slate-500 flex items-center justify-center">
          <BsShieldLock className="h-6 w-6" />
        </div>
        <h2 className="mt-4 text-lg font-semibold text-slate-800">No access to this page</h2>
        <p className="mt-2 text-sm text-slate-500">
          This section is not enabled for your account. Ask your clinic admin to grant it from
          Settings &gt; Permissions.
        </p>
        <button
          onClick={() => navigate('/dashboard', { replace: true })}
          className="mt-6 px-4 py-2 rounded-xl bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
